/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-09 16:46:40
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-09 16:51:44
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/AdaptorSelection/index.tsx
 */
import React from 'react';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import css from './css.module.less';

import { Radio, OriSelect } from 'src/components/Antd';
const Option = OriSelect.Option;

const AdaSelection = (props) => {
  const { list, value, onChange, title, disabled } = props;
  return (
    <Section bottomBorder>
      <ItemWrapper title={title}>
        <Radio
          className={css.radioContainer}
          radioList={list}
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
      </ItemWrapper>
    </Section>
  );
};
const AdaSelect = (props) => {
  const { list, value, onChange, title, disabled } = props;
  return (
    <Section bottomBorder>
      <ItemWrapper title={title}>
        <OriSelect
          value={value}
          onChange={onChange}
          size='large'
          disabled={disabled}>
          {list.map((i) => {
            const { label, value } = i;
            return (
              <Option value={value} key={value}>
                {label}
              </Option>
            );
          })}
        </OriSelect>
      </ItemWrapper>
    </Section>
  );
};
export { AdaSelect };
export default AdaSelection;
